import React, { Component } from 'react';
import getMousePos from '../../utils/getMousePos';
import { Link } from 'gatsby';
import * as styles from '../../components/basic/gridCallout.module.scss';

export default function mouseTranslate(
  WrappedComponent,
  imgRanges,
  textRanges
) {
  return class MouseTranslate extends Component {
    constructor() {
      super();
      this.state = {
        imgTransform: 'translate3d(0, 0, 0)',
        textTransform: 'translate3d(0, 0, 0)',
      };
      this.interval = null;
      this.isTouch = false;
    }
    componentDidMount() {
      window.addEventListener('touchstart', this.triggerTouch);
    }
    componentWillUnmount() {
      clearInterval(this.interval);
      window.removeEventListener('touchstart', this.triggerTouch);
    }
    triggerTouch = () => {
      this.isTouch = true;
    };
    position3dFunction = () => {
      if (this.isTouch) {
        return;
      }
      if (typeof this.relMousePos !== 'undefined') {
        const bounds = this.el.getBoundingClientRect();
        this.setState({
          imgTransform: getTransform(this.relMousePos, bounds, imgRanges),
          textTransform: getTransform(this.relMousePos, bounds, textRanges),
        });
      }
    };
    handleMouseEnter = () => {
      if (this.isTouch) {
        return;
      }
      this.interval = setInterval(this.position3dFunction, 100);
    };
    handleMouseMove = e => {
      var mousepos = getMousePos(e),
        // Document scrolls.
        docScrolls = {
          left: document.body.scrollLeft + document.documentElement.scrollLeft,
          top: document.body.scrollTop + document.documentElement.scrollTop,
        },
        bounds = this.el.getBoundingClientRect();
      // Mouse position relative to the main element
      this.relMousePos = {
        x: mousepos.x - bounds.left - docScrolls.left,
        y: mousepos.y - bounds.top - docScrolls.top,
      };
    };
    handleMouseLeave = () => {
      clearInterval(this.interval);
      this.setState({
        imgTransform: 'translate3d(0, 0, 0)',
        textTransform: 'translate3d(0, 0, 0)',
      });
    };
    renderDisplayText() {
      const displayText = (
        <div>
          <span className={`label ${styles.indicatorlabel}`}>
            {this.props.label}
          </span>
          <span className={styles.indicatorLine} />
          <div className={styles.calloutTitle}>
            <h3 dangerouslySetInnerHTML={{ __html: this.props.title }} />
          </div>
        </div>
      );
      return this.props.path ? (
        <Link to={this.props.path} className={`${styles.link}`}>
          {displayText}
        </Link>
      ) : (
        displayText
      );
    }

    render() {
      return (
        <div
          onMouseMove={this.handleMouseMove}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          ref={el => {
            this.el = el;
          }}
        >
          <WrappedComponent
            {...this.props}
            imgTransform={this.state.imgTransform}
            textTransform={this.state.textTransform}
          />
        </div>
      );
    }
  };
}

function getTransform(relMousePos, bounds, ranges) {
  const vals = {
    x: (ranges.x[1] - ranges.x[0]) / bounds.width * relMousePos.x + ranges.x[0],
    y:
      (ranges.y[1] - ranges.y[0]) / bounds.height * relMousePos.y + ranges.y[0],
  };

  return `translate3d(${vals.x}px, ${vals.y}px, 0)`;
}
